function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @file Highway default transition that handle DOM animations.
 * @author Anthony Du Pont <bulldog@dogstudio.co>
 */
var Transition = /*#__PURE__*/function () {
  /**
   * @arg {object} wrap — [data-router-wrapper] node
   * @arg {object} name — Transition name
   * @constructor
   */
  function Transition(wrap, name) {
    _classCallCheck(this, Transition);

    // The [data-router-wrapper] is the only main information we need since the role of
    // the transition is to show/hide the required DOM elements.
    this.wrap = wrap; // Save transition name for later.

    this.name = name;
  }
  /**
   * Add the view in DOM and play an `in` transition if one is defined.
   *
   * @return {object} Promise
   * @param {object} datas - Set of datas
   */


  _createClass(Transition, [{
    key: "show",
    value: function show(_ref) {
      var _this = this;

      var trigger = _ref.trigger,
          contextual = _ref.contextual;
      // Get View
      var to = this.wrap.lastElementChild;
      var from = this.wrap.firstElementChild; // Promise

      return new Promise(function (resolve) {
        // The `in` method in encapsulated in the `show` method make transition
        // code easier to write. This way you don't have to define any Promise
        // in your transition code and focus on the transition itself.
        if (!contextual) {
          // Change Attributes
          to.setAttribute('data-transition-in', _this.name);
          to.removeAttribute('data-transition-out', _this.name); // Call transition attached to the view.

          _this["in"] && _this["in"]({
            to: to,
            from: from,
            trigger: trigger,
            done: resolve
          });
        } else {
          // Change Attributes
          to.setAttribute('data-transition-in', contextual.name);
          to.removeAttribute('data-transition-out', contextual.name); // Call the contextual transition.

          contextual["in"] && contextual["in"]({
            to: to,
            from: from,
            trigger: trigger,
            done: resolve
          });
        }
      });
    }
    /**
     * Play an `out` transition if one is defined and remove the view from DOM.
     *
     * @return {object} Promise
     * @param {object} datas - Set of datas
     */

  }, {
    key: "hide",
    value: function hide(_ref2) {
      var _this2 = this;

      var trigger = _ref2.trigger,
          contextual = _ref2.contextual;
      // Get view
      var from = this.wrap.firstElementChild; // Promise

      return new Promise(function (resolve) {
        // The `out` method in encapsulated in the `hide` method make transition
        // code easier to write. This way you don't have to define any Promise
        // in your transition code and focus on the transition itself.
        if (!contextual) {
          // Change Attributes
          from.setAttribute('data-transition-out', _this2.name);
          from.removeAttribute('data-transition-in', _this2.name); // Call the transition attached to the view.

          _this2.out && _this2.out({
            from: from,
            trigger: trigger,
            done: resolve
          });
        } else {
          // Change Attributes
          from.setAttribute('data-transition-out', contextual.name);
          from.removeAttribute('data-transition-in', contextual.name); // Call the contextual transition.

          contextual.out && contextual.out({
            from: from,
            trigger: trigger,
            done: resolve
          });
        }
      });
    }
  }]);

  return Transition;
}();

export { Transition as default };